import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { SpecialRequirement } from "Globals/Models/SpecialRequirement";

export class SpecialRequirementsStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private specialRequirements: SpecialRequirement[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.specialRequirements = initialState.specialRequirements;
    }

    @MobX.action
    public getSpecialRequirementsName(specialRequirementsId: string | null): string {
        if (specialRequirementsId == "0" || specialRequirementsId == null || specialRequirementsId == "") return "Error";
        let value = this.getSortedByOrdinal.find((value) => specialRequirementsId === value.id);
        return value ? value.name : "Unknown";
    }

    @MobX.computed
    public get getSortedByOrdinal(): SpecialRequirement[] {
        return this.specialRequirements.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getSpecialRequirementsOptions(): KeyValuePair[] {
        let placeholder = {
            key: "Please select",
            value: "placeholder",
        } as KeyValuePair;

        let options = this.getSortedByOrdinal.map((value) => ({ value: value.id, key: value.name })) as KeyValuePair[];

        options.unshift(placeholder);

        return options;
    }
}
